import { Component, Inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { SharedModule } from '../../../../shared/shared.module';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ImageService } from '../../../../../common/services/image/image.service';
import { ButtonTriggerEvent } from '../../../../../common/components/button/button.component';
import { NgIf } from '@angular/common';
import { ConfigService } from '../../../../../common/services/config/config.service';
import { Itinerary } from '../../../models/itinerary';
import { TripPlannerService } from '../../../services/trip.planner.service';
import { catchError, delay, of } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ColorPickerComponent } from '../../../../../common/components/color.picker/color.picker.component';
import { VisitorService } from '../../../../shared/services/visitor.service';
import { UserTrip } from '../../../../shared/models/vititor.trip.storage.command';
import { ExportPDFService } from 'src/app/modules/shared/services/export.pdf.service';

@Component({
  selector: 'ig-share-itinerary-modal',
  standalone: true,
  imports: [MatIcon, SharedModule, NgIf],
  templateUrl: './share.itinerary.modal.component.html',
  styleUrl: './share.itinerary.modal.component.scss',
})
export class ShareItineraryModalComponent {
  form: FormGroup;
  contactForm: FormGroup;
  emailErrorMsg = ''; //'Please enter a correct email.';
  shareData: ShareItineraryModalData;
  linkCopied = false;

  defaultImg = `https://iti-images.s3.amazonaws.com/events/26727d50-f9b0-5318-c4a2-4057bfd4bdef.webp`;
  defaultAvatar = `https://iti-images.s3.amazonaws.com/events/46a894bb-0ef0-270c-7118-e3bacdad1c9a.webp`;

  constructor(
    public imgService: ImageService,
    public tripService: TripPlannerService,
    public visitorService: VisitorService,
    public pdfService: ExportPDFService,
    private _fb: FormBuilder,
    private dialogRef: MatDialogRef<ShareItineraryModalComponent>,
    @Inject(MAT_DIALOG_DATA) data: ShareItineraryModalData
  ) {
    this.shareData = Object.assign({}, data);

    this.form = this._fb.group({
      emails: [null, [Validators.required]],
    });

    this.contactForm = this._fb.group({
      name: [null, [Validators.required]],
      number: [null, []],
      email: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern(ConfigService.config.emailPattern),
        ])
      ),
      comment: [null, [Validators.required]],
    });
  }

  sendEmail(event: ButtonTriggerEvent) {
    if (this.shareData.isEditMode) {
      alert(`You cannot share the itinerary in the edit mode.`);
      event.immediateComplete();
      return;
    }

    // const base64Imgs = await this.pdfService.cropImages(command, totalItemsCount);
    // const dynamicHTML = this.createBannerDiv(base64Imgs);

    let imgUrl = this.defaultImg;
    if (this.shareData.type === 'trip') {
      imgUrl = (this.shareData.itinerary as UserTrip)?.days[0]?.attractions[0]
        ?.item?.cover?.source;
    } else {
      imgUrl = this.shareData.itinerary['image'];
    }
    imgUrl = this.imgService.imageSourceUrl(imgUrl);

    let description = '';
    if (this.shareData.type === 'trip') {
      const trip = this.shareData.itinerary as UserTrip;
      description =
        trip?.days.length > 1
          ? `${trip?.days[0]?.dateText} - ${trip?.days.last()?.dateText}`
          : `${trip?.days[0]?.dateText}`;
    } else {
      description = this.shareData.itinerary.description;
    }

    let profilePicture = '';
    if (this.shareData.user) {
      profilePicture = this.shareData.user.profilePicture || this.defaultAvatar;
    }

    const emailEle = `<div style="width:100%;background:#f7f7f7">
      <div style="width:50%;margin:auto;min-width:600px">
        <div style="text-align:center;text-transform:uppercase;font-size:24px;font-weight:bold;padding:20px 40px;background:#e7e7e7;color:#6b6b6b">A${
          this.shareData.type === 'itinerary' ? 'n' : ''
        } ${this.shareData.type} has been shared with you!
          <div style="display:flex;gap:12px;align-items:center;justify-content:center;${
            !profilePicture ? 'display:none' : ''
          }">
            <img src="${profilePicture}" style="width: 40px;height: 40px;border-radius:50%" />
            <div style="font-weight:bold;font-size:14px">${
              this.shareData.user?.userName
            }</div>
          </div>
        </div>
        <img src="${imgUrl}" style="width: 100%;" />
        <div style="background:#e7e7e7;color:#6b6b6b;padding:20px">

          <b>${this.shareData.itinerary['title']}</b>
          <div>${description || ''}</div>
          <div style="background:#60a5fa;color:#fff;text-align:center;width:fit-content;border-radius:4px;font-weight:bold;font-size:18px;margin:20px auto;cursor:pointer"><a href="${
            window.location.href
          }" style="color:#fff;text-decoration:none;padding:12px 30px;display:block">Click here to view the ${
      this.shareData.type
    }</a></div>
          <div style="margin-top:20px">Or copy the link below to explore the full ${
            this.shareData.type
          } and get ideas for your adventure.</div>
           <a href="${window.location.href}">${window.location.href}</a>

           <div style="margin-top:20px">
            Happy travels!
           </div>
           <div>
            ${this.shareData.cityName}
           </div>
          </div>
      </div>
    </div>`;

    this.tripService
      .sendEmails(this.form.get('emails').value, window.location.href, emailEle)
      .subscribe((data) => {
        event.success();
      });
  }

  shareByEmailApp() {
    if (this.shareData.isEditMode) {
      alert(`You cannot share the itinerary in the edit mode.`);
      return;
    }

    window.location.href =
      this.shareData.type === 'itinerary'
        ? ConfigService.config.tripPlanner.itineraryMailTo.replace(
            '${url}',
            window.location.href
          )
        : ConfigService.config.tripPlanner.userTripMailTo.replace(
            '${url}',
            window.location.href
          );
  }

  sendInquiry(event: ButtonTriggerEvent) {
    if (this.shareData.isEditMode) {
      alert(`You cannot send inquiry in the edit mode.`);
      event.immediateComplete();
      return;
    }

    this.visitorService
      .getInquiryEmail(this.shareData.hubName)
      .pipe(
        catchError((err) => {
          event.immediateComplete();
          return of(err);
        })
      )
      .subscribe((email) => {
        this.visitorService
          .sendHelp({
            name: this.contactForm.get('name').value,
            email: this.contactForm.get('email').value,
            comment: this.contactForm.get('comment').value,
            number: this.contactForm.get('number').value,
            inquiryEmail: email,
            link: window.location.href,
          })
          .pipe(
            catchError((err) => {
              event.immediateComplete();
              return of(err);
            })
          )
          .subscribe(() => {
            event.success();
          });
      });
  }

  shareToFacebook() {
    if (this.shareData.isEditMode) {
      alert(`You cannot share the itinerary in the edit mode.`);
      return;
    }

    let link = '',
      baseURL = window.location.href.includes('localhost')
        ? 'http://localhost:3000/api/common/html'
        : 'https://api.imgoingcalendar.com/api/common/html';
    if (this.shareData.type === 'itinerary') {
      link = `${baseURL}%3Ftype=itinerary%26id=${
        this.shareData.itinerary['_id']
      }%26url=${encodeURIComponent(window.location.href)}`;
    } else {
      link = `${baseURL}%3Ftype=trip%26id=${
        this.shareData.itinerary['_id']
      }%26name=${this.shareData.itinerary['title']}%26url=${encodeURIComponent(
        window.location.href
      )}`;
    }

    window.open(
      'https://www.facebook.com/sharer/sharer.php?u=' + link,
      'facebook-share-dialog',
      'width=800,height=600'
    );
  }

  tweetEvent() {
    if (this.shareData.isEditMode) {
      alert(`You cannot share the itinerary in the edit mode.`);
      return;
    }

    const shareLink = ConfigService.config.eventShare.tweet
      .replace('${text}', this.shareData.itinerary.title)
      .replace('${url}', encodeURIComponent(window.location.href));
    window.open(shareLink, '', 'width=800,height=600');
  }

  get link() {
    if (
      this.shareData.type === 'itinerary' &&
      !this.shareData.itinerary['isActive']
    ) {
      return `Unable to generate a link for an unpublished itinerary!`;
    }
    return window.location.href;
  }

  sendRequest(event: ButtonTriggerEvent) {
    if (this.shareData.isEditMode) {
      alert(`You cannot share the itinerary in the edit mode.`);
      event.immediateComplete();
      return;
    }
    this.tripService
      .sendEmails(this.form.get('emails').value, window.location.href)
      .subscribe((data) => {
        event.success();
      });
  }

  copy() {
    this.visitorService.copyToClip(this.link);
    this.linkCopied = true;
    setTimeout(() => {
      this.linkCopied = false;
    }, 4000);
  }

  public close(): void {
    this.dialogRef.close();
  }
}

export interface ShareItineraryModalData {
  itinerary: Itinerary | UserTrip;
  hubName: string;
  cityName: string;
  isEditMode: boolean;
  type: 'trip' | 'itinerary';
  user: {
    profilePicture: string;
    userName: string;
  };
}
